import React from 'react'
import { UserContextProvider } from '../context/UserContext'
import Layout from '../components/Layout'
import StrapiTable from '../sections/StrapiTable'
import { BERITA_TABLE_HEADERS } from '../constants/table-header'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { deleteNews, getAllNews } from '../services/news.service'

const ListBerita = () => {
  const navigate = useNavigate()
  const onDelete = async (id) => {
    try {
      await deleteNews({ id })
      navigate(0)
    } catch (error) {
      toast.error(error?.response?.data?.error?.message ?? 'Error')
    }
  }

  return (
    <UserContextProvider>
      <Layout activeNav="Berita">
        <div className="p-3 lg:pl-0">
          <StrapiTable
            title="Berita"
            headers={BERITA_TABLE_HEADERS}
            createLink="/konten/berita/create"
            fetchFunction={getAllNews}
            onDelete={(id) => onDelete(id)}
            onEdit={(id) => navigate(`/konten/berita/edit/${id}`)}
          />
        </div>
      </Layout>
    </UserContextProvider>
  )
}

export default ListBerita
